import React from "react";
import {cart} from "./cart";
import {SelectTwo} from "../selecttwo";
export {CreditRow};

class CreditRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {opened: false, payments: this.props.ranges[0]};
    }


    render() {

        let rate = 0;
        if(typeof this.props.rates == 'undefined'){
            rate = 1;
        }else{
            rate = this.props.rates[this.props.ranges.indexOf(this.state.payments)];
        }

        return (
            <div className={"credit-item tab-pane fade" + (this.props.openedTab ? " active show" : "")} id={"mob" + this.props.rewrite} role="tabpanel">
                <div className={"credit-item__header" + (this.state.opened ? '' : ' collapsed')} onClick={(e) => this.setState({opened: !this.state.opened})}>
                    <div className="credit-item__logo"><img height="" src={"/theme/main/i/logo-" + this.props.rewrite + (this.props.rewrite == 'pumb' ? '.svg' : '.png')} alt={this.props.short}/></div>
                    <div className="credit-item__title">{this.props.title}</div>
                    <div className="btn btn_ghost btn-sm credit-item__btn-toggle">{this.state.opened ? lajax.t('Закрыть') : lajax.t('Открыть')}</div>
                </div>
                <div className={"credit-item__body collapse" + (this.state.opened ? ' show' : '')} id={this.props.rewrite}>
                    <div className="credit-item__num-pays">{lajax.t('Количество платежей')}</div>
                    <div className="credit-item__list-opts">
                        {this.props.ranges.map((val) => (
                            <div className="credit-item__opt-item" key={"radio" + val}>
                                <input id={this.props.rewrite + val} type="radio" name={this.props.rewrite} value={val} checked={this.state.payments == val} onChange={e => this.setState({payments: val})}/>
                                <label htmlFor={this.props.rewrite + val}>{val} {tools.declOfNums(val, lajax.t('Платеж,Платежа,Платежей').split(','))}</label>
                            </div>
                        ))}
                    </div>
                    <div className="credit-item__mob-select">
                        <div className="select-box">
                            <SelectTwo
                                name={"paylater_monthes"}
                                onChange={(name, val) => this.setState({payments: val})}
                                value={this.state.paymets}
                                minimumResultsForSearch={"-1"}
                            >{this.props.ranges.map(val => (
                                <option value={val}>{val} {tools.declOfNums(val, lajax.t('Платеж,Платежа,Платежей').split(','))}</option>
                            ))}
                            </SelectTwo>

                        </div>
                    </div>
                    <div className="credit-item__month-pay">{lajax.t('Ежемесячный плятеж')}: <span>{tools.displayPrice(this.props.cart.total_price / this.state.payments)} <i>₴</i></span>
                    </div>
                    <div className="credit-item__cols">
                        <div className="credit-item__left-side">
                            <div className="credit-item__ichar">
                                <div className="credit-item__ichar__label">{lajax.t('Первый платеж')}:</div>
                                <div className="credit-item__ichar__value">{tools.displayPrice(this.props.cart.total_price / this.state.payments)} ₴</div>
                            </div>
                            <div className="credit-item__ichar">
                                <div className="credit-item__ichar__label">{lajax.t('Сумма заказа')}:</div>
                                <div className="credit-item__ichar__value">{tools.displayPrice(this.props.cart.total_price)} ₴</div>
                            </div>
                            <div className="credit-item__ichar">
                                <div className="credit-item__ichar__label">{lajax.t('Сумма в кредит')}:</div>
                                <div className="credit-item__ichar__value">{tools.displayPrice(this.props.cart.total_price / rate)} ₴</div>
                            </div>
                        </div>
                        <div className="credit-item__right-side">
                            <a className="btn btn-primary btn-md" href={window.orderLink}>{lajax.t("Оформить")}</a>
                        </div>
                    </div>
                    <div className="credit-item__conditions"><a href={window.paymentsLink+'#'+this.props.rewrite}>{lajax.t('Условия кредитования')}</a></div>
                </div>
            </div>
        );
    }
}